import 'react-circular-progressbar/dist/styles.css';
import { useContext } from 'react';
import SessionContext from '../../../library/Core/SessionContext';
import CurrentJobInformationRightPanel from './CurrentJobInformationRightPanel';
import { SmartContext } from '../../../library/Core/SmartContext';
import AlumniSteps from './../profile-edit/pg-higher-studies/AlumniSteps';
import { getCurrentInformationData, getWorkingStatusInfo } from '../../../library/Service/getCurrentStatus';

let SchoolLogo = sessionStorage.getItem('school-image') as any;
const CurrentJobInformationLayout = (props: any) => {
    const { state, dispatch } = useContext(SmartContext);

    const { sessionState } = useContext(SessionContext);
    const userStatusCode = sessionState?.userStatusCode;
    const userTypeCode = sessionState?.userTypeCode;
    const profileStatusCode = sessionState?.profileStatusCode; 
    const isInternalHeaderActive = userTypeCode != 'SUPER_ADMIN' && userTypeCode != 'INSTITUTE_ADMIN' && userStatusCode != 'ACTIVE' && profileStatusCode != 'basic-info-complete' && profileStatusCode != 'COMPLETE'

    const previewCardData = getWorkingStatusInfo(state);

    console.log('previewCardData', previewCardData);

    return (
        <>
            <div className="main-wrap">
                <div className="leftPane">
                    <div className="leftPaneWrap">
                        {isInternalHeaderActive && (
                            <div className="leftPaneHeaderWrap">
                                <div className="leftPaneHeader">
                                    <img src={SchoolLogo} alt="" />
                                    <label className="user_name">
                                        Hey{' '}
                                        <span>
                                            {sessionState?.firstName} {sessionState?.lastName}
                                        </span>
                                    </label>
                                </div>
                            </div>
                        )}
                        <div className="leftPaneBodyWrap">
                            <div className="leftPaneBody">
                                <div className="qs_body" data-aos="fade-up" data-nextpage="test.html">
                                    <AlumniSteps />
                                    <div className="steps_questions">{props.children}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="rightPane basic-information bg-green-gradient">
                    <div className="rightPaneWrap">
                        {isInternalHeaderActive && (
                            <div className="rightPaneHeaderWrap">
                                <div className="rightPaneHeader">
                                    <label className="user_name">
                                        Hey{' '}
                                        <span>
                                            {sessionState?.firstName} {sessionState?.lastName}
                                        </span>
                                    </label>
                                </div>
                            </div>
                        )}
                        {/* right panel */}
                        <CurrentJobInformationRightPanel data={previewCardData} />
                        {/* end of right panel */}
                    </div>
                </div>
            </div>
        </>
    );
};

export default CurrentJobInformationLayout;
